var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-box"},[_c('p',{staticClass:"p1"},[_vm._v("\n      "+_vm._s(_vm.dataInfo.title)+"\n    ")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],domProps:{"innerHTML":_vm._s(_vm.dataInfo.content)}})]),_c('VFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }